import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    id: String
  };

  declare idValue: string;
  declare formViewed: boolean;
  declare formSubmitted: boolean;
  declare observer: IntersectionObserver;

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting === true) {
          this.trackFormViewed();
          this.observer.disconnect();
        }
      },
      { threshold: [1] }
    );

    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  trackFormViewed() {
    if (this.formViewed) { return }

    this.formViewed = true;
    window.analytics.track(
      "Mailing List Form Seen",
      {
        promptId: this.idValue
      }
    );
  }

  trackFormSubmitted() {
    if (this.formSubmitted) { return }

    this.formSubmitted = true;
    window.analytics.track(
      "Mailing List Form Submitted",
      {
        promptId: this.idValue
      }
    );
  }
}
